module.exports = __webpack_public_path__ + "static/working-advisor-expecting-couple.d840df1d.webp";